export const MEMBERSHIP_TARGET_TYPE = [
  { label: "경리지원", value: "client" },
  { label: "세무회사", value: "tax" },
];